import Assistant from "../assistant/Assistant";
import ExitButton from "../buttons/ExitButton";
import { ErrorMessage, Field, Formik } from "formik";
import * as Yup from "yup";
import StateObjectiveOrIndicatorInput from "../inputs/StateObjectiveOrIndicatorInput";
import TypeOfAdvancementInput from "../inputs/TypeOfAdvancementInput";
import SendFormButton from "../buttons/SendFormButton";
import React, { useEffect } from "react";
import styled, { css } from "styled-components";
import { BaseModal } from "./modalStyle";
import { useDispatch, useSelector } from "react-redux";
import { FunctionalModal } from "./FunctionalModal";
import { loadUsers } from "../user/usersAction";
import { FormFormik, InputTextFormik } from "../inputs/InputStyle";

import SelectUserInputFormik from "../inputs/SelectUserInputFormik";
import { patchIndicator, postIndicator } from "../indicator/indicatorsAction";
import { loadProject } from "../project/one-project/projectAction";
import { loadAllObjectives } from "../objective/ObjectiveActions";
import useSortItems from "../../custom-hooks/useSortItems";
import { DisplayForHead } from "../../permissions/DisplayAccordingToRole";
import { IS_HEAD } from "../../permissions/roleTypes";
import TextareaFormikInput from "../inputs/TextareaFormikInput";

const IndicatorModal = ({
  indicatorId = 0,
  projectId = 0,
  parentObjective = {},
  setOpen,
}) => {
  const dispatch = useDispatch();
  const {
    title,
    comment,
    target,
    advancement,
    advancementType,
    pilot,
    endDate,
    onGoing,
  } = useSelector((state) => state.indicator);

  const { id: currentUserId } = useSelector((state) => state.currentUser);
  const { users } = useSelector((state) => state.users);
  const project = useSelector((state) => state.project);
  const currentUser = useSelector((state) => state.currentUser);

  const { sortOneItemTopOfTheList } = useSortItems();

  useEffect(() => {
    dispatch(loadUsers());
  }, [dispatch]);

  const close = () => {
    setOpen(false);
  };
  const handleSubmitIndicators = async (data) => {
    data.pilotId = Number(data.pilotId);
    if (indicatorId === 0) {
      await dispatch(postIndicator(data));
    } else {
      await dispatch(patchIndicator(indicatorId, data));
    }
    if (project.id !== 0) {
      await dispatch(loadProject(project.id));
    } else {
      await dispatch(loadAllObjectives(currentUserId));
    }
    close();
  };

  const IndicatorSchema = Yup.object().shape({
    title: Yup.string()
      .max(250, "Le titre de ce résultat clé est trop long")
      .required("Le champs est requis"),
    comment: Yup.string().max(1000, "Ce commentaire est trop long").nullable(),
    target: Yup.string().required("Le champs est requis"),
    advancement: Yup.number().min(0),
    endDate: Yup.string().nullable(),
    advancementType: Yup.string().required("Le type d'avancement est requis"),
    onGoing: Yup.boolean().required("Le champs est requis"),
    pilotId: Yup.string().required("Il est obligatoire de choisir un pilote"),
  });

  const displayUsers = () => {
    if (indicatorId !== 0) {
      return sortOneItemTopOfTheList(users, { id: pilot.id });
    } else {
      return users;
    }
  };

  const hasException = () => {
    return (
      parentObjective.pilot.id === currentUser.id ||
      (project.id !== 0 ? project.pilot.id === currentUser.id : false) ||
      (project?.copilot?.id ? project.copilot.id === currentUser.id : false) ||
      (project.axisSponsor ? project.axisSponsor.id === currentUser.id : false)
    );
  };

  return (
    <FunctionalModal
      setOpen={setOpen}
      component={
        <Modal $mode={IS_HEAD(currentUser.roles) || hasException()}>
          <Formik
            enableReinitialize
            initialValues={{
              title: indicatorId ? title : "",
              comment: indicatorId ? comment : "",
              target: indicatorId ? target : 0,
              advancement: indicatorId ? advancement : 0,
              advancementType: indicatorId ? advancementType : "percentage",
              pilotId: indicatorId ? pilot.id.toString() : project ? project.pilot.id : "",
              endDate: indicatorId ? endDate : "",
              onGoing: indicatorId ? onGoing : true,
              okrId: parentObjective.id,
            }}
            validationSchema={IndicatorSchema}
            onSubmit={handleSubmitIndicators}
          >
            {({ isValid, isSubmitting, values, setFieldValue }) => (
              <>
                <FirstSection>
                  <h1>
                    {" "}
                    {indicatorId ? "Modifier" : "Ajouter"} un résultat clé{" "}
                  </h1>
                  <ExitButton closeUpdate={close} />
                </FirstSection>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <Assistant
                    context={{
                      object: "indicator",
                      project: project.name,
                      comment: project.comment,
                      objective: parentObjective.title,
                    }}
                    onSelect={(item) => {
                      setFieldValue("title", item.name);
                      setFieldValue("comment", item.description);
                    }}
                  />
                </div>
                <h4 className={"txt-align w-100"}>
                  {" "}
                  résultat clé relié à l'objectif :{" "}
                  <span className={"fw-700"}>
                    {" "}
                    {parentObjective.hasOwnProperty("title") &&
                      parentObjective.title}{" "}
                  </span>
                </h4>
                <Form>
                  <SendFormButton
                      state={isValid && !isSubmitting}
                      actionName={indicatorId ? "Modifier" : "Ajouter"}
                  />
                  <div>
                    <label htmlFor="title"> Nom du résultat clé * </label>
                    <InputTextFormik
                      name="title"
                      placeholder={"Nom du résultat clé"}
                    />
                    <ErrorMessage
                      name="title"
                      render={(msg) => (
                        <div>
                          <p className="error-text"> {msg} </p>
                        </div>
                      )}
                    />
                  </div>
                  <CommentSection>
                    <label htmlFor="comment"> Commentaires </label>
                    <TextareaFormikInput
                      name="comment"
                      rows="4"
                      placeholder={"Vos commentaires ici"}
                    />
                    <ErrorMessage
                      name="comment"
                      render={(msg) => (
                        <div>
                          <p className="error-text"> {msg} </p>
                        </div>
                      )}
                    />
                  </CommentSection>

                  <DisplayForHead
                    hasException={hasException()}
                    component={
                      <SelectUserInputFormik
                        pilotId={values.pilotId}
                        users={displayUsers()}
                        label={"responsable"}
                      />
                    }
                  />

                  <ErrorMessage
                    name="pilotId"
                    render={(msg) => (
                      <div>
                        <p className="error-text"> {msg} </p>
                      </div>
                    )}
                  />
                  <DisplayForHead
                    hasException={hasException()}
                    component={
                      <>
                        <Deadline className={"flex-row gap-1"}>
                          <label htmlFor="endDate"> Échéance </label>
                          <Field name="endDate" type={"date"} max={parentObjective?.endDate}/>
                          <ErrorMessage
                            name="endDate"
                            render={(msg) => (
                              <div>
                                <p className="error-text"> {msg} </p>
                              </div>
                            )}
                          />
                        </Deadline>
                        <hr />
                      </>
                    }
                  />

                  <StateContainer>
                    <label htmlFor="onGoing"> Statut </label>
                    <StateObjectiveOrIndicatorInput value={values.onGoing} />
                  </StateContainer>
                  <hr />
                  <TypeOfAdvancementInput values={values} />
                </Form>
              </>
            )}
          </Formik>
        </Modal>
      }
    />
  );
};

const Modal = styled(BaseModal)`
  align-items: center;
  width: 100vw;
  overflow-x: hidden;
  height: fit-content;
  gap: 1rem;
  position: unset;

  .tag-selected {
    background-color: #fafafa !important;
    border: 2px solid rgba(82, 215, 131, 1);
    color: rgba(33, 37, 41, 1);
  }

  @media (min-width: 768px) {
    width: 600px;
    ${(props) => {
      switch (props.$mode) {
        case true:
          return css`
            position: unset;
          `;
        default:
          return css`
            position: absolute;
          `;
      }
    }}
  }
`;
const StateContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
`;

const Deadline = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;

  label {
    white-space: nowrap;
  }
`;

const CommentSection = styled.div`
  display: flex;
  flex-direction: column;
`;
const FirstSection = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;

  h1 {
    flex-grow: 1;
  }

  button {
    display: flex;
    align-items: flex-start;
    height: 100%;
  }
`;

const Form = styled(FormFormik)`
  gap: 2rem;
  max-width: 90%;
`;
export default IndicatorModal;
